(function () {
  'use strict';

  const NAV_DATA = [
    { label: 'Brakes & Suspension', icon: '🔧', url: '/collections/brake-pads',
      children: [
        { label: 'Brake Pads', url: '/collections/brake-pads' },
        { label: 'Brake Rotors', url: '/collections/brake-rotors' },
        { label: 'Shocks & Struts', url: '/collections/shocks-and-struts' },
        { label: 'Suspension Lift Kits', url: '/collections/suspension-lift-kits' },
        { label: 'Body Lift Kits', url: '/collections/body-lift-kits' },
        { label: 'Lowering Kits', url: '/collections/lowering-kits' },
        { label: 'UTV Lift Kits', url: '/collections/utv-lift-kits' },
      ]
    },
    { label: 'Engine & Drivetrain', icon: '⚙️', url: '/collections/engine-oil',
      children: [
        { label: 'Engine Oil', url: '/collections/engine-oil' },
        { label: 'Spark Plugs', url: '/collections/spark-plugs' },
        { label: 'Alternator', url: '/collections/alternator' },
        { label: 'AC Compressor', url: '/collections/ac-compressor' },
        { label: 'Mass Airflow Sensors', url: '/collections/mass-airflow-sensors-1' },
        { label: 'Performance Parts', url: '/collections/performance-parts' },
      ]
    },
    { label: 'Filters & Fluids', icon: '🛢️', url: '/collections/oil-filter',
      children: [
        { label: 'Oil Filter', url: '/collections/oil-filter' },
        { label: 'Air Filter', url: '/collections/air-filter' },
        { label: 'Cabin Air Filter', url: '/collections/cabin-air-filter' },
        { label: 'Battery', url: '/collections/battery' },
      ]
    },
    { label: 'Electrical & Lighting', icon: '💡', url: '/collections/lighting-accessories',
      children: [
        { label: 'Battery', url: '/collections/battery' },
        { label: 'Alternator', url: '/collections/alternator' },
        { label: 'Wiper Blades', url: '/collections/wiper-blades' },
        { label: 'Headlight Bulbs', url: '/collections/headlight-bulb' },
        { label: 'Lighting & Accessories', url: '/collections/lighting-accessories' },
      ]
    },
    { label: 'Truck & Off-Road', icon: '🚙', url: '/collections/body-lift-kits',
      children: [
        { label: 'Body Lift Kits', url: '/collections/body-lift-kits' },
        { label: 'Suspension Lift Kits', url: '/collections/suspension-lift-kits' },
        { label: 'Bumpers', url: '/collections/bumpers' },
        { label: 'Winches & Accessories', url: '/collections/winches-accessories' },
        { label: 'Bed Covers', url: '/collections/bed-covers' },
        { label: 'Fender Flares', url: '/collections/fender-flares' },
        { label: 'Steps & Running Boards', url: '/collections/steps-running-boards' },
        { label: 'Wheels', url: '/collections/wheels' },
        { label: 'Wheel Spacers & Adapters', url: '/collections/wheel-spacers-adapters' },
        { label: 'UTV Accessories', url: '/collections/utv-accessories' },
      ]
    },
    { label: 'Accessories', icon: '🧼', url: '/collections/interior-mats',
      children: [
        { label: 'Interior & Mats', url: '/collections/interior-mats' },
        { label: 'Cargo Management', url: '/collections/cargo-management' },
        { label: 'Decals & Graphics', url: '/collections/decals-graphics' },
        { label: 'Lighting & Accessories', url: '/collections/lighting-accessories' },
      ]
    },
    { label: 'Shop by Vehicle', icon: '🚗', url: '/collections',
      children: [
        { label: 'Acura', url: '/collections/acura-1' },
        { label: 'Audi', url: '/collections/audi' },
        { label: 'BMW', url: '/collections/bmw' },
        { label: 'Buick', url: '/collections/buick' },
        { label: 'Cadillac', url: '/collections/cadillac' },
        { label: 'Chevrolet', url: '/collections/chevrolet' },
        { label: 'Ferrari', url: '/collections/ferrari' },
        { label: 'Ford', url: '/collections/ford' },
        { label: 'GMC', url: '/collections/gmc' },
        { label: 'Honda', url: '/collections/honda' },
        { label: 'Hyundai', url: '/collections/hyundai' },
        { label: 'Kia', url: '/collections/kia' },
        { label: 'Lamborghini', url: '/collections/lamborghini' },
        { label: 'Lexus', url: '/collections/lexus' },
        { label: 'Maserati', url: '/collections/maserati' },
        { label: 'Mazda', url: '/collections/mazda' },
        { label: 'Mercedes-Benz', url: '/collections/mercedes-benz' },
        { label: 'Nissan', url: '/collections/nissan' },
        { label: 'Porsche', url: '/collections/porsche' },
        { label: 'Subaru', url: '/collections/subaru' },
        { label: 'Toyota', url: '/collections/toyota' },
      ]
    },
  ];

  function buildHamburger() {
    const btn = document.createElement('button');
    btn.className = 'gm-hamburger';
    btn.setAttribute('aria-label', 'Open navigation menu');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = `
      <div class="gm-hamburger__bars">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <span class="gm-hamburger__label">Menu</span>
    `;
    return btn;
  }

  function buildDrawer() {
    const overlay = document.createElement('div');
    overlay.className = 'gm-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    const drawer = document.createElement('nav');
    drawer.className = 'gm-drawer';
    drawer.setAttribute('aria-label', 'Site navigation');
    drawer.setAttribute('aria-hidden', 'true');

    drawer.innerHTML = `
      <div class="gm-drawer__header">
        <span class="gm-drawer__title">Browse Categories</span>
        <button class="gm-drawer__close" aria-label="Close menu">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <div class="gm-drawer__body">
        <ul class="gm-nav__list"></ul>
      </div>
      <div class="gm-drawer__footer">
        <a class="gm-drawer__footer-link" href="/pages/contact">📞 Contact Us</a>
        <a class="gm-drawer__footer-link" href="/account">👤 My Account</a>
      </div>
    `;

    const navList = drawer.querySelector('.gm-nav__list');

    NAV_DATA.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'gm-nav__item';
      const hasChildren = item.children && item.children.length > 0;

      li.innerHTML = `
        <div class="gm-nav__top">
          <a class="gm-nav__top-link" href="${item.url}">
            <span class="gm-nav__icon">${item.icon}</span>
            <span>${item.label}</span>
          </a>
          ${hasChildren ? `<button class="gm-nav__chevron" aria-label="Expand ${item.label}" aria-expanded="false"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/></svg></button>` : ''}
        </div>
        ${hasChildren ? `<ul class="gm-nav__sub">${item.children.map(c => `<li><a class="gm-nav__sub-link" href="${c.url}">${c.label}</a></li>`).join('')}</ul>` : ''}
      `;

      if (hasChildren) {
        const btn = li.querySelector('.gm-nav__chevron');
        const sub = li.querySelector('.gm-nav__sub');
        btn.addEventListener('click', () => {
          const expanded = li.classList.toggle('is-expanded');
          btn.setAttribute('aria-expanded', expanded);
          sub.setAttribute('aria-hidden', !expanded);
        });
      }

      navList.appendChild(li);
    });

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
    return { drawer, overlay, closeBtn: drawer.querySelector('.gm-drawer__close') };
  }

  function open(drawer, overlay, hamburger) {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger.classList.add('is-open');
    document.body.classList.add('gm-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
  }

  function close(drawer, overlay, hamburger) {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger.classList.remove('is-open');
    document.body.classList.remove('gm-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
  }

  function init() {
    const { drawer, overlay, closeBtn } = buildDrawer();
    const hamburger = buildHamburger();

    // Try to inject into the header before any existing children
    const header = document.querySelector(
      '.header__heading-link, .header, header[class*="header"], [id*="header"]'
    );
    const headerParent = header ? header.closest('.header, header, [class*="header"]') : null;

    if (headerParent) {
      headerParent.insertBefore(hamburger, headerParent.firstChild);
    } else {
      // Fallback: fixed top-left
      hamburger.style.cssText = 'position:fixed;top:8px;left:8px;z-index:1997;';
      document.body.appendChild(hamburger);
    }

    hamburger.addEventListener('click', () => {
      drawer.classList.contains('is-open') ? close(drawer, overlay, hamburger) : open(drawer, overlay, hamburger);
    });
    overlay.addEventListener('click', () => close(drawer, overlay, hamburger));
    closeBtn.addEventListener('click', () => close(drawer, overlay, hamburger));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(drawer, overlay, hamburger);
    });
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();